export default function MessageSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-8 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        {/* Section label */}
        <div className="flex items-center justify-center gap-4 mb-10">
          <div className="w-10 h-px bg-primary-500" />
          <span
            className="text-xs tracking-[0.3em] text-primary-700 uppercase"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            About Us
          </span>
          <div className="w-10 h-px bg-primary-500" />
        </div>

        {/* Title */}
        <h2
          className="text-3xl md:text-4xl lg:text-5xl mb-10 leading-relaxed"
          style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 700, color: '#025ab0' }}
        >
          OLカンパニーとは？
        </h2>

        {/* Message body */}
        <div className="space-y-6 text-foreground-700 leading-[2.2] text-sm md:text-base">
          <p className="text-lg md:text-xl lg:text-2xl">
            <strong className="text-foreground-950 font-semibold">
              「LOCAL FIRST」を社訓に掲げる<br className="md:hidden" />株式会社OLカンパニー。
            </strong>
          </p>
          <p>
            OL＝OITA LOCALの頭文字です。
          </p>
          <p>
            大分県のローカルタレント・森祐作のマネジメントを目的とする個人事務所として設立され、<br className="hidden md:inline" />今では大分の特産品かぼすの生産、販売も手掛けております。
          </p>
          <p className="text-foreground-950 font-medium text-lg md:text-xl lg:text-2xl">
            私たちは、大分の魅力を世界へ届けるために、いままでにない価値を創造しつづけます。
          </p>
        </div>

        {/* Decorative divider */}
        <div className="flex items-center justify-center gap-3 mt-14">
          <div className="w-1.5 h-1.5 rounded-full bg-primary-500" />
          <div className="w-1.5 h-1.5 rounded-full bg-secondary-500" />
          <div className="w-1.5 h-1.5 rounded-full bg-primary-500" />
        </div>
      </div>
    </section>
  );
}